module.exports = __webpack_public_path__ + "static/img/Sofwaveパルス_発注フォーム.26b4099.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Sofwaveパルス_発注フォーム.png
// module id = nimQ
// module chunks = 0